
.header {
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  color: #142F43;
}